import React from 'react';
import {
    PlusOutlined,
    LogoutOutlined,
    RedoOutlined,
    UserOutlined,
    LockOutlined
} from '@ant-design/icons';
import { Button, Input, message, Modal, Table, Divider, Form, Checkbox } from 'antd';
import { Api } from '../../../lib/api';
import { createUser } from '../../../lib/signUpUtils';

import '../styles.scss';
import { USER_NAMES } from '../components/pageNameConstants';
import DeleteWarningModal from '../components/DeleteWarningModal';

export default class Security extends React.PureComponent {
    state = {
        visible: false,
        createVisible: false,
        showDeleteModal: false,
        users: [],
        username: ''
    };

    componentDidMount() {
        this.getUsers();
    }

    getUsers = async () => {
        await Api.getUsers().then((users) => {
            this.setState({ users: users, createVisible: false });
        });
    }

    deleteUsers = (id) => {
        return Api.deleteUser(id);
    }

    resetPassword = async (values) => {
        if (values.userName !== 'sysAdmin') {
            await Api.login(values).then(async (result) => {
                if (result !== false) {
                    // this.authenticated = true;
                    Api.updateUser(values.username, values.newPassword).then((res) => {
                        if (res) {
                            this.setState({ visible: false });
                            document.getElementById('reset-password').reset();
                            message.success('Your Password has been updated. ', 6);
                        } else {
                            alert('The system is not able to update your password, try agin please');
                        }
                    });
                } else {
                    alert("Your username and password don't match, please try again ");
                }
            });
        } else {
            alert('YOU CAN NOT UPDATE SYS ADMIN AND YOU SHOULD NOT UPDATE SYS ADMIN ');
        }
    };
    resetPasswordAdmin = async (values) => {
        // this.authenticated = true;
        Api.updateUser(this.state.username, values.newPassword).then((res) => {
            if (res) {
                this.setState({ visible: false });
                document.getElementById('reset-password').reset();

                message.success('Your Password has been updated. ', 6);
            } else {
                alert('The system is not able to update your password, try agin please');
            }
        });
    };
    signUp = async (values) => {
        await createUser(values.username, values.password, values.admin, () => {
            document.getElementById('create-password').reset();
            this.getUsers();
        });
    };

    closeDeleteModal = () => {
        this.setState({showDeleteModal: false});
    }

    render() {
        // <div className="section polarity-types page-card">
        return (
            <div className="section page-card">
                <div className="create-button">
                    <div className="user-info">
                        {localStorage.getItem('username')} ({localStorage.getItem('role')})
                    </div>
                    {localStorage.getItem('role') === 'admin' && (
                        <Button
                            type="primary"
                            shape="round"
                            icon={<PlusOutlined />}
                            onClick={() => this.setState({ createVisible: true })}
                        >
                            New User
                        </Button>
                    )}
                    &nbsp; &nbsp;
                    {localStorage.getItem('username') !== 'admin' && (
                        <Button shape="round" icon={<RedoOutlined />} onClick={() => this.setState({ visible: true })}>
                            Reset Password
                        </Button>
                    )}
                    &nbsp; &nbsp;
                    <Button
                        danger
                        shape="round"
                        icon={<LogoutOutlined />}
                        onClick={() => {
                            localStorage.clear();
                            window.location.pathname = '/';
                        }}
                    >
                        Log Out
                    </Button>
                </div>
                <Modal
                    title="New User"
                    open={this.state.createVisible}
                    onCancel={() => {
                        this.setState({ createVisible: false });
                        document.getElementById('create-password').reset();
                    }}
                    footer={null}
                >
                    <Form name="register" onFinish={this.signUp} className="login-form" id="create-password">
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username'
                                }
                            ]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Password" />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                    }
                                })
                            ]}
                        >
                            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Password" />
                        </Form.Item>
                        <Form.Item
                            name="admin"
                            valuePropName="checked"
                            //wrapperCol={{ offset: 8, span: 16 }}
                        >
                            <Checkbox>Make this account a system admin</Checkbox>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="login-form-button">
                                Register
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <DeleteWarningModal
                    isOpen={this.state.showDeleteModal}
                    itemTypeToDelete={USER_NAMES}
                    itemNameToDelete={this.state.username}
                    itemRecordToDelete={this.state.username}
                    closeCallback={this.closeDeleteModal}
                    update={this.getUsers}
                    delete={this.deleteUsers}
                >
                </DeleteWarningModal>
                <Modal
                    title="Reset Password"
                    open={this.state.visible}
                    onCancel={() => this.setState({ visible: false })}
                    footer={null}
                >
                    <Form
                        name="register1"
                        id="reset-password"
                        onFinish={localStorage.getItem('role') !== 'admin' ? this.resetPassword : this.resetPasswordAdmin}
                        className="login-form"
                    >
                        {localStorage.getItem('role') !== 'admin' && (
                            <Form.Item
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your username'
                                    }
                                ]}
                            >
                                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                            </Form.Item>
                        )}

                        {localStorage.getItem('role') !== 'admin' && (
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your old password'
                                    }
                                ]}
                            >
                                <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Old Password" />
                            </Form.Item>
                        )}
                        <Form.Item
                            name="newPassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input.Password
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                placeholder="New Password"
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            dependencies={['newPassword']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                    }
                                })
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                placeholder="New Password"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" icon={<RedoOutlined />} htmlType="submit" className="login-form-button">
                                Reset Password
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                {localStorage.getItem('role') === 'admin' && (
                    <Table
                        columns={[
                            {
                                title: 'Name',
                                dataIndex: 'username',
                                key: 'username',
                                render: (text, record) => <div>{text}</div>
                            },
                            {
                                title: 'Role',
                                dataIndex: 'type',
                                key: 'type'
                            },
                            {
                                title: 'Action',
                                key: 'action',
                                render: (text, record) => (
                                    <div className="action-buttons">
                                        <Button
                                            shape="round"
                                            icon={<RedoOutlined />}
                                            onClick={() => this.setState({ visible: true, username: record.username })}
                                        >
                                            Reset Password
                                        </Button>
                                        <Divider type="vertical" />
                                        <Button
                                            type="link"
                                            style={{ color: '#e60013' }}
                                            onClick={() => this.setState({showDeleteModal: true, username: record.username})}
                                            >
                                            Delete
                                        </Button>
                                    </div>
                                )
                            }
                        ]}
                        dataSource={this.state.users}
                        pagination={{ pageSize: 8 }}
                        rowKey="id"
                    />
                )}
            </div>
        );
    }
}